import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaMapMarkerAlt, FaTrophy, FaWhatsapp } from 'react-icons/fa';
import { useAppContext } from '../../context/AppContext';
import logo from '../../assets/logo.png';

const DEFAULT_EVENT_NAME = 'EVENT TAEKWONDO';

const Footer = () => {
  const { settings } = useAppContext();

  const eventName = settings?.event_name?.trim() || DEFAULT_EVENT_NAME;
  const eventYear = settings?.event_date ? new Date(settings.event_date).getFullYear() : new Date().getFullYear();
  const location = settings?.location || 'Lokasi Belum Diatur';
  const contactPerson = settings?.contact_person || 'Kontak Belum Diatur';
  const email = settings?.email || '';
  const registrationOpen = settings?.is_registration_open !== false;
  const backendUrl = process.env.REACT_APP_BACKEND || process.env.REACT_APP_BACKEND_URL || '';
  const logoSrc = settings?.web_logo ? `${backendUrl}/uploads/settings/${settings.web_logo}` : logo;

  const waNumber = String(contactPerson).replace(/^0/, '62').replace(/\D/g, '');

  return (
    <footer className="sulteng-footer">
      <div className="sulteng-footer__pattern" />
      <div className="container position-relative">
        <div className="sulteng-footer__cta">
          <div>
            <span className="sulteng-footer__eyebrow">
              <FaTrophy /> Portal Resmi Kejuaraan
            </span>
            <h2>{eventName}</h2>
            <p>
              {settings?.event_description ||
                'Pastikan data club dan atlet sudah lengkap sebelum batas akhir pendaftaran resmi panitia.'}
            </p>
          </div>
          {registrationOpen ? (
            <Link to="/register" className="btn sulteng-footer__cta-btn">
              Daftar Sekarang
            </Link>
          ) : (
            <button type="button" className="btn sulteng-footer__cta-btn" disabled>
              Pendaftaran Ditutup
            </button>
          )}
        </div>

        <div className="row g-4 g-lg-5 align-items-start">
          <div className="col-12 col-lg-5">
            <div className="sulteng-footer__brand">
              <span className="sulteng-footer__brand-icon">
                <img src={logoSrc} alt={`Logo ${eventName}`} />
              </span>
              <span>
                <strong>{eventName}</strong>
                <small>Taekwondo Championship {eventYear}</small>
              </span>
            </div>
            <p className="sulteng-footer__desc">
              {settings?.event_description ||
                'Kejuaraan Taekwondo dengan sistem kompetisi modern untuk mendorong prestasi, sportivitas, dan regenerasi atlet.'}
            </p>
          </div>

          <div className="col-6 col-lg-2">
            <h3 className="sulteng-footer__title">Navigasi</h3>
            <ul className="sulteng-footer__links">
              <li><Link to="/">Beranda</Link></li>
              <li><Link to="/informasi">Informasi</Link></li>
              <li><Link to="/cek-data">Cek Data</Link></li>
              <li><Link to="/login">Masuk</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <h3 className="sulteng-footer__title">Kategori</h3>
            <ul className="sulteng-footer__links">
              <li><span>Kyorugi</span></li>
              <li><span>Poomsae</span></li>
              <li><span>Prestasi</span></li>
              <li><span>Festival</span></li>
            </ul>
          </div>

          <div className="col-12 col-lg-3">
            <h3 className="sulteng-footer__title">Kontak Panitia</h3>
            <ul className="sulteng-footer__contacts">
              <li>
                <FaMapMarkerAlt />
                <span>{location}</span>
              </li>
              <li>
                <FaWhatsapp />
                {waNumber ? (
                  <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noreferrer">{contactPerson}</a>
                ) : (
                  <span>{contactPerson}</span>
                )}
              </li>
              <li>
                <FaEnvelope />
                {email ? <a href={`mailto:${email}`}>{email}</a> : <span>Email belum diatur</span>}
              </li>
            </ul>
          </div>
        </div>

        <div className="sulteng-footer__bottom">
          <p>Copyright {new Date().getFullYear()} {eventName}. All Rights Reserved.</p>
          <p>{location}</p>
        </div>
      </div>

      <style>{`
        .sulteng-footer {
          position: relative;
          overflow: hidden;
          margin-top: auto;
          padding: 5.5rem 0 2rem;
          color: #ffffff;
          background: linear-gradient(180deg, #14532d 0%, #052e16 100%);
          border-top-left-radius: 3rem;
          border-top-right-radius: 3rem;
        }

        .sulteng-footer__pattern {
          position: absolute;
          inset: 0;
          opacity: 0.08;
          background-image: radial-gradient(#facc15 10%, transparent 10%), radial-gradient(#ffffff 10%, transparent 10%);
          background-size: 42px 42px;
          background-position: 0 0, 21px 21px;
          pointer-events: none;
        }

        .sulteng-footer__cta {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          justify-content: space-between;
          margin-bottom: 4rem;
          padding: 2rem;
          border: 1px solid rgba(250, 204, 21, 0.24);
          border-radius: 28px;
          background: rgba(22, 101, 52, 0.72);
          box-shadow: 0 24px 70px rgba(0, 0, 0, 0.22);
          backdrop-filter: blur(16px);
        }

        .sulteng-footer__eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
          color: #facc15;
          font-size: 0.78rem;
          font-weight: 900;
          text-transform: uppercase;
        }

        .sulteng-footer__cta h2 {
          margin: 0 0 0.75rem;
          font-size: 2.6rem;
          font-weight: 900;
        }

        .sulteng-footer__cta p {
          max-width: 640px;
          margin: 0;
          color: #bbf7d0;
          font-weight: 600;
          line-height: 1.7;
        }

        .sulteng-footer__cta-btn {
          align-self: flex-start;
          white-space: nowrap;
          border-radius: 999px;
          color: #ffffff;
          background: linear-gradient(135deg, #f97316, #ea580c);
          box-shadow: 0 18px 35px rgba(234, 88, 12, 0.28);
          font-weight: 900;
          padding: 0.9rem 1.4rem;
        }

        .sulteng-footer__cta-btn:hover {
          color: #ffffff;
          transform: translateY(-2px);
          box-shadow: 0 24px 48px rgba(234, 88, 12, 0.36);
        }

        .sulteng-footer__cta-btn:disabled {
          color: #ffffff;
          background: #64748b;
          box-shadow: none;
          opacity: 1;
          cursor: not-allowed;
        }

        .sulteng-footer__brand {
          display: flex;
          align-items: center;
          gap: 0.85rem;
          margin-bottom: 1.25rem;
        }

        .sulteng-footer__brand-icon {
          width: 54px;
          height: 54px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 auto;
          color: #14532d;
          background: #facc15;
          border-radius: 18px;
          font-size: 1.5rem;
          box-shadow: 0 14px 30px rgba(250, 204, 21, 0.22);
          overflow: hidden;
        }

        .sulteng-footer__brand-icon img {
          width: 48px;
          height: 48px;
          object-fit: contain;
        }

        .sulteng-footer__brand span:last-child {
          display: flex;
          flex-direction: column;
          line-height: 1.05;
        }

        .sulteng-footer__brand strong {
          font-size: 1.3rem;
          font-weight: 900;
          text-transform: uppercase;
        }

        .sulteng-footer__brand small {
          margin-top: 0.25rem;
          color: #fb923c;
          font-size: 0.7rem;
          font-weight: 900;
          text-transform: uppercase;
        }

        .sulteng-footer__desc {
          max-width: 500px;
          color: #d1fae5;
          font-weight: 500;
          line-height: 1.75;
        }

        .sulteng-footer__title {
          margin-bottom: 1rem;
          color: #facc15;
          font-size: 0.78rem;
          font-weight: 900;
          text-transform: uppercase;
        }

        .sulteng-footer__links,
        .sulteng-footer__contacts {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .sulteng-footer__links {
          display: flex;
          flex-direction: column;
          gap: 0.78rem;
        }

        .sulteng-footer__links a,
        .sulteng-footer__links span {
          color: #d1fae5;
          font-size: 0.92rem;
          font-weight: 700;
          text-decoration: none;
        }

        .sulteng-footer__links a:hover {
          color: #facc15;
        }

        .sulteng-footer__contacts {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .sulteng-footer__contacts li {
          display: flex;
          gap: 0.75rem;
          align-items: flex-start;
          color: #d1fae5;
          font-size: 0.9rem;
          font-weight: 650;
          line-height: 1.55;
        }

        .sulteng-footer__contacts svg {
          margin-top: 0.2rem;
          color: #facc15;
          flex: 0 0 auto;
        }

        .sulteng-footer__contacts a {
          color: #d1fae5;
          text-decoration: none;
        }

        .sulteng-footer__contacts a:hover {
          color: #facc15;
        }

        .sulteng-footer__bottom {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          justify-content: space-between;
          margin-top: 3rem;
          padding-top: 1.4rem;
          border-top: 1px solid rgba(255, 255, 255, 0.12);
          color: rgba(209, 250, 229, 0.72);
          font-size: 0.78rem;
          font-weight: 800;
          text-transform: uppercase;
        }

        .sulteng-footer__bottom p {
          margin: 0;
        }

        @media (min-width: 768px) {
          .sulteng-footer {
            border-top-left-radius: 5rem;
            border-top-right-radius: 5rem;
          }

          .sulteng-footer__cta,
          .sulteng-footer__bottom {
            flex-direction: row;
            align-items: center;
          }

          .sulteng-footer__cta-btn {
            align-self: center;
          }
        }

        @media (max-width: 575.98px) {
          .sulteng-footer__cta {
            padding: 1.4rem;
          }

          .sulteng-footer__cta h2 {
            font-size: 2rem;
          }

          .sulteng-footer__brand strong {
            font-size: 1.05rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
